import { useState } from 'react';

const useSelectableItems = (initialItems = []) => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectItem = (item) => {
    setSelectedItems((prevSelected) =>
      prevSelected.some(i => i.id === item.id)
        ? prevSelected.filter(i => i.id !== item.id)
        : [...prevSelected, item]
    );
  };

  const handleBulkSelect = (allItems) => {
    setSelectedItems(
      allItems.length === selectedItems.length ? [] : allItems
    );
  };

  return { selectedItems, handleSelectItem, handleBulkSelect };
};

export default useSelectableItems;
